// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.platform-admin-shell {
  display: flex;
  height: 100vh;
  background: #fff;
  font-family: Inter, sans-serif;
}

.platform-admin-sidebar {
  width: 264px;
  flex-shrink: 0;
  border-right: 1px solid #e5e9ec;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.platform-admin-sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 29px 24px 24px 32px;
  cursor: pointer;
}

.platform-admin-sidebar-logo svg {
  flex-shrink: 0;
}

.platform-admin-sidebar-badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 100px;
  border: 1px solid #148dfd;
  background: #e6f4ff;
  color: #148dfd;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.platform-admin-sidebar-section-label {
  padding: 8px 32px;
  color: #93a1b0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.platform-admin-sidebar-nav {
  flex: 1;
  overflow-y: auto;
}

.platform-admin-nav-item {
  height: 48px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 16px 4px;
  padding: 0 16px;
  border-radius: 9px;
  color: #405261;
  font-size: 15px;
  line-height: 18px;
  text-decoration: none;
}

.platform-admin-nav-item svg {
  width: 20px;
  height: 20px;
  color: #93a1b0;
}

.platform-admin-nav-item:hover {
  background: #f9fafa;
}

.platform-admin-nav-item.active {
  background: #f9fafa;
  color: #061522;
  font-weight: 500;
}

.platform-admin-nav-item.active svg {
  color: #148dfd;
}

.platform-admin-nav-count {
  margin-left: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 100px;
  background: #fff1f0;
  color: #ff4d4f;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.platform-admin-sidebar-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
}

.platform-admin-sidebar-footer:hover {
  background: #f9fafa;
}

.platform-admin-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.platform-admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid #eef2f6;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  min-height: 80px;
  box-sizing: border-box;
}

.platform-admin-header-title {
  margin: 0;
  color: #061522;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
}

.platform-admin-header-subtitle {
  margin: 4px 0 0;
  color: #405261;
  font-size: 13px;
  line-height: 18px;
}

.platform-admin-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.platform-admin-tabs-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-end;
  border-bottom: 1px solid #eef2f6;
}

.platform-admin-tab-item {
  background: none;
  border: none;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #405261;
  padding: 10px 0 11px;
  margin-bottom: -1px;
  border-bottom: 2px solid transparent;
}

.platform-admin-tab-item:hover {
  color: #061522;
}

.platform-admin-tab-item.active {
  color: #061522;
  font-weight: 600;
  border-bottom-color: #148dfd;
}
`, "",{"version":3,"sources":["webpack://./src/components/platformAdmin/platformAdmin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B","sourcesContent":[".platform-admin-shell {\n  display: flex;\n  height: 100vh;\n  background: #fff;\n  font-family: Inter, sans-serif;\n}\n\n.platform-admin-sidebar {\n  width: 264px;\n  flex-shrink: 0;\n  border-right: 1px solid #e5e9ec;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.platform-admin-sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 29px 24px 24px 32px;\n  cursor: pointer;\n}\n\n.platform-admin-sidebar-logo svg {\n  flex-shrink: 0;\n}\n\n.platform-admin-sidebar-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 100px;\n  border: 1px solid #148dfd;\n  background: #e6f4ff;\n  color: #148dfd;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.platform-admin-sidebar-section-label {\n  padding: 8px 32px;\n  color: #93a1b0;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.platform-admin-sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.platform-admin-nav-item {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0 16px 4px;\n  padding: 0 16px;\n  border-radius: 9px;\n  color: #405261;\n  font-size: 15px;\n  line-height: 18px;\n  text-decoration: none;\n}\n\n.platform-admin-nav-item svg {\n  width: 20px;\n  height: 20px;\n  color: #93a1b0;\n}\n\n.platform-admin-nav-item:hover {\n  background: #f9fafa;\n}\n\n.platform-admin-nav-item.active {\n  background: #f9fafa;\n  color: #061522;\n  font-weight: 500;\n}\n\n.platform-admin-nav-item.active svg {\n  color: #148dfd;\n}\n\n.platform-admin-nav-count {\n  margin-left: auto;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 100px;\n  background: #fff1f0;\n  color: #ff4d4f;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.platform-admin-sidebar-footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 16px;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.platform-admin-sidebar-footer:hover {\n  background: #f9fafa;\n}\n\n.platform-admin-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.platform-admin-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #eef2f6;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n  min-height: 80px;\n  box-sizing: border-box;\n}\n\n.platform-admin-header-title {\n  margin: 0;\n  color: #061522;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.platform-admin-header-subtitle {\n  margin: 4px 0 0;\n  color: #405261;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.platform-admin-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.platform-admin-tabs-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  align-items: flex-end;\n  border-bottom: 1px solid #eef2f6;\n}\n\n.platform-admin-tab-item {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #405261;\n  padding: 10px 0 11px;\n  margin-bottom: -1px;\n  border-bottom: 2px solid transparent;\n}\n\n.platform-admin-tab-item:hover {\n  color: #061522;\n}\n\n.platform-admin-tab-item.active {\n  color: #061522;\n  font-weight: 600;\n  border-bottom-color: #148dfd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
